import React, { useState } from 'react'
import '../styles/SentakuStyle.css'

const imageSel = './images/select.png';

function SentakuB() {

      const [isHovered, setIsHovered] = useState(false);

        return (

    <div
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    className='imageSelectionDiv'>

    { isHovered ? (
        <div className="isHoveredDiv">
        <img src={imageSel} id="img1" alt=""/>
        <a href='/artwork' id='watashiSel'>アートワーク</a>
        <img src={imageSel} id="img2" alt=""/>
        </div>
    ) : (<a href='artwork.html' id='watashiSel'>artwork</a>
    )}
      </div>
  )
}

export default SentakuB
